import { createQueryKeys } from '@lukemorales/query-key-factory';

export const coBrokeAdmin = createQueryKeys('coBrokeAdmin', {
  settings: null,
});
